<template>
  <div :class="`pb-2 component_backtest_key_pad`">
    <div class="row">
      <div class="col-md-12 text-right menu">
        <!-- Para copiar backtest -->
        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Copy backtest"
          @click="copyBacktest()"
        >
          <b-icon-link></b-icon-link>
        </span>

        <!-- Para descargar excel del backtest -->
        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Download complete report"
          @click="downloadReport()"
        >
          <b-icon-cloud-arrow-down></b-icon-cloud-arrow-down>
        </span>

        <!-- Para mostrar el backtest -->
        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Show modal information"
          @click="showDetails()"
        >
          <b-icon-journal-medical></b-icon-journal-medical>
        </span>

        <!-- Para agregar a favoritos -->
        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Add to favorite"
          v-if="!isFavorites()"
          @click="addFavorite()"
        >
          <b-icon-bookmark-star></b-icon-bookmark-star>
        </span>

        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Delete to favorite"
          v-else
          @click="deleteFavorite()"
        >
          <b-icon-bookmark-star-fill></b-icon-bookmark-star-fill>
        </span>

        <!-- Para eliminar el backtest -->
        <span
          style="font-size: 22px"
          v-b-tooltip.hover
          title="Delete backtest and data"
          @click="deleteBacktest()"
          v-if="parseInt($store.state.backtest_detail.status) != 2"
        >
          <b-icon-trash></b-icon-trash>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Keypad",
  data() {
    return {
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
          <g clip-path="url(#clip0_1634_940)">
          <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
          </g>
          <defs>
          <clipPath id="clip0_1634_940">
          <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
          </clipPath>
          </defs>
          </svg> Success`,
    };
  },
  methods: {
    isFavorites() {
      return (
        this.$store.state.backtest_favorites.filter(
          (b) => b.backtest_token === this.$store.state.token_backtest_detail
        ).length > 0
      );
    },
    addFavorite() {
      this.$store.commit("bwfs_add_backtest_favorites", {
        backtestToken: this.$store.state.token_backtest_detail,
        vm: this,
      });
    },
    deleteFavorite() {
      this.$store.commit("bwfs_delete_backtest_favorites", {
        backtestToken: this.$store.state.token_backtest_detail,
        vm: this,
      });
    },
    deleteBacktest() {
      if (window.confirm("Are you sure to delete this backtest?")) {
        this.$store.commit("bwfs_delete_backtest", {
          token: this.$store.state.token_backtest_detail,
          vm: this,
        });
        this.$emit("handleDeleteBacktest");
      }
    },
    showDetails() {
      this.$bvModal.show("modal-show-backtest");
    },
    copyBacktest() {
      let backtest = this.$store.state.backtest_detail;
      if (this.$store.state.backtest_conditions.length > 0) {
        let conditions = [];
        let cc = JSON.stringify(this.$store.state.backtest_conditions);
        cc = JSON.parse(cc);
        cc.forEach((c) => {
          let a = { ...c, _isCopy: true };
          a.condition = { ...JSON.parse(a.condition.condition) };
          conditions.push(a);
        });
        backtest.configurations = conditions;
      }
      localStorage.setItem(
        "copyBacktest",
        this.$crypto.encrypt(JSON.stringify(backtest))
      );
      this.$toastr.success("Success copy backtest", `${this.success}`);
    },
    downloadReport() {
      const payload = {
        vm: this,
        data: {
          backtest_token: this.$store.state.token_backtest_detail,
        },
        server: "https://backtesting.bwfs.creedandbear.com:8080",
      };
      this.$store.commit("bwfs_download_report_backtest", payload);
    },
  },
};
</script>
